import { MIN_OUTPUT_VIDEO_DURATION } from '../constants'
import { CreationToolSourceFile } from '../types'
import CreationTool from '../types/creation-tool'
import CreationToolFileType from '../types/file-type'
import CreationToolOutputType from '../types/output-type'
import CreationToolStep from '../types/steps'

/**
 * Returns an array of creation steps based on the file added and output type.
 * @param {File|string} source Source file object or url
 * @param {string} outputType Current creation output type (gif, sticker, video, etc.)
 * @returns {object[]}
 */
const getCreationSteps = (
    sources: CreationToolSourceFile[],
    tool: CreationTool,
    outputType: CreationToolOutputType
): CreationToolStep[] => {
    const steps: CreationToolStep[] = []
    const isBulk = sources.length > 1
    let videoSourceCount = 0
    let animatedSourceCount = 0

    if (tool === CreationTool.SuperCut) {
        return [CreationToolStep.Upload]
    }

    sources.forEach(({ type, duration, isAnimated }) => {
        if (
            duration > MIN_OUTPUT_VIDEO_DURATION &&
            (type === CreationToolFileType.VIDEO || type === CreationToolFileType.VIDEO_EMBED)
        ) {
            videoSourceCount++
        }
        if (isAnimated) {
            animatedSourceCount++
        }
    })

    // if this is a video, first go to trim (unless its coming from supercut)
    if (videoSourceCount > 0 && !isBulk) {
        steps.push(CreationToolStep.VideoTrim)
    }

    // if upload, go to finalize step
    if (tool === CreationTool.Upload) {
        steps.push(CreationToolStep.Upload)
        return steps
    }

    // if output type is a sticker, go to cut out phase
    if (outputType === CreationToolOutputType.Sticker) {
        steps.push(CreationToolStep.CutOut)

        // if source file is a still image, go to animate phase
        if (animatedSourceCount === 0) {
            steps.push(CreationToolStep.Animate)
        }

        steps.push(CreationToolStep.Upload)
    } else {
        steps.push(CreationToolStep.Decorate)
    }

    return steps
}

export default getCreationSteps
